import {useSyncExternalStore} from 'react';
import {getSupplierSession} from '../features/supplier/supplierAccess';

const eventName='withpot-list-settings';
const fallback=new Map<string,string>();
export function listSettingsKey(scope:string) {
    const session=getSupplierSession();
    const owner=session?.role==='supplier'?`supplier:${session.supplier?.id ?? 'unknown'}`:'team';
    return `withpot:list-settings:v1:${owner}:${scope}`;
}
const read=(key:string)=>{if(fallback.has(key))return fallback.get(key)!;try{return localStorage.getItem(key) ?? '{}';}catch{return '{}';}};
const object=(raw:string):Record<string,unknown>=>{try{const value=JSON.parse(raw);return value && typeof value==='object' && !Array.isArray(value)?value:{};}catch{return {};}};
export function readListSettings(scope:string) {return object(read(listSettingsKey(scope)));}
export function writeListSettings(scope:string,changes:Record<string,unknown>) {
    const key=listSettingsKey(scope),raw=JSON.stringify({...object(read(key)),...changes});
    try{localStorage.setItem(key,raw);fallback.delete(key);}catch{fallback.set(key,raw);}
    window.dispatchEvent(new Event(eventName));
}
const subscribe=(notify:()=>void)=>{
    window.addEventListener(eventName,notify);window.addEventListener('storage',notify);window.addEventListener('supplierSessionChanged',notify);
    return()=>{window.removeEventListener(eventName,notify);window.removeEventListener('storage',notify);window.removeEventListener('supplierSessionChanged',notify);};
};
export function useLocalListValues(scope:string,defaults:Record<string,unknown>) {
    const key=listSettingsKey(scope);
    const raw=useSyncExternalStore(subscribe,()=>read(key),()=> '{}');
    const saved=object(raw),values={...defaults};
    for(const [name,initial] of Object.entries(defaults)) {
        const value=saved[name];
        if(value!==undefined && (initial===null || (Array.isArray(initial)?Array.isArray(value):typeof value===typeof initial))) values[name]=value;
    }
    return values;
}
